import script from "./info_event.vue?vue&type=script&setup=true&lang=js"
export * from "./info_event.vue?vue&type=script&setup=true&lang=js"

import "./info_event.vue?vue&type=style&index=0&id=46644b8f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46644b8f"]])

export default __exports__